<template>
    <q-page padding>
        <div class="relative-position loader">
            <div class="row">
                <div class="col-12">
                    <q-card class="md-card q-mt-lg q-pa-lg relative-position" color="white" text-color="black">
                      <q-card-title>
                        Helpful Links for Quickbooks
                        <span slot="subtitle">Payment service is provided by Intuit Payments Inc</span>
                      </q-card-title>
                        <q-card-separator/>
                        <q-card-main>
                            <q-list highlight>
                                <q-item>
                                    <q-item-side>
                                        <q-item-tile icon="link" color="primary"/>
                                    </q-item-side>
                                    <q-item-main>
                                        <q-btn @click="openLink('https://qbo.intuit.com')" flat color="primary"> Quickbooks Online</q-btn>
                                    </q-item-main>
                                </q-item>
                                <q-item>
                                    <q-item-side>
                                        <q-item-tile icon="link" color="primary"/>
                                    </q-item-side>
                                    <q-item-main>
                                        <q-btn @click="openLink(merchantCenterUrl)" flat color="primary"> Merchant Terminal Home</q-btn>
                                    </q-item-main>
                                </q-item>
                                <q-item>
                                    <q-item-side>
                                        <q-item-tile icon="link" color="primary"/>
                                    </q-item-side>
                                    <q-item-main>
                                        <q-btn @click="openLink('https://merchantcenter.intuit.com/msc/portal/reporting')" flat color="primary"> Merchant Transactions</q-btn>
                                    </q-item-main>
                                </q-item>
                                <q-item>
                                    <q-item-side>
                                        <q-item-tile icon="link" color="primary"/>
                                    </q-item-side>
                                    <q-item-main>
                                        <q-btn @click="openLink('https://merchantcenter.intuit.com/msc/portal/tpc/cc')" flat color="primary"> Merchant Charge a Card</q-btn>
                                    </q-item-main>
                                </q-item>
                                <q-item>
                                    <q-item-side>
                                        <q-item-tile icon="link" color="primary"/>
                                    </q-item-side>
                                    <q-item-main>
                                        <q-btn @click="openLink('https://merchantcenter.intuit.com/portal/authsec/portal/qbms/Manage+merchant+account/View+and+Download+Statements')" flat color="primary"> Merchant Statements</q-btn>
                                    </q-item-main>
                                </q-item>
                                <q-item>
                                    <q-item-side>
                                        <q-item-tile icon="link" color="primary"/>
                                    </q-item-side>
                                    <q-item-main>
                                        <q-btn @click="openLink(quickbooksConnectUrl)" flat color="primary"> Reconnect AGC Application to Quickbooks</q-btn>
                                    </q-item-main>
                                </q-item>
                            </q-list>
                        </q-card-main>
                    </q-card>
                </div>
            </div>
        </div>
    </q-page>
</template>

<script>
import {openURL} from 'quasar'
import environmentMixin from '../../../mixins/environment'

export default {
  name: 'Entry',
  mixins: [environmentMixin],
  methods: {
    openLink (link) {
      openURL(link)
    }
  }
}
</script>
